import { render, staticRenderFns } from "./weight-allocation.vue?vue&type=template&id=4b64e488&scoped=true&"
import script from "./weight-allocation.vue?vue&type=script&lang=ts&"
export * from "./weight-allocation.vue?vue&type=script&lang=ts&"
import style0 from "./weight-allocation.vue?vue&type=style&index=0&id=4b64e488&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64e488",
  null
  
)

export default component.exports